import React from "react";
import useFilter from "./useFilter";
import Select from "react-select";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const Filter = () => {
  const { formik, basicData, handleReset } = useFilter();
  return (
    <div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Supplier
        </label>
        <Select
          id="supplier"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          isMulti
          name="supplier"
          options={basicData?.data?.suppliers || []}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={basicData?.data?.suppliers?.filter((m) =>
            formik.values.supplier?.includes?.(m._id)
          )}
          onChange={(value) =>
            formik.setFieldValue(
              "supplier",
              value?.map((item) => item?._id) || []
            )
          }
          menuPlacement="auto"
          isClearable
        />
      </div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Shop
        </label>
        <Select
          id="shop"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          isMulti
          name="shop"
          options={basicData?.data?.shops || []}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={basicData?.data?.shops?.filter((m) =>
            formik.values.shop?.includes?.(m._id)
          )}
          onChange={(value) =>
            formik.setFieldValue(
              "shop",
              value?.map((item) => item?._id) || []
            )
          }
          menuPlacement="auto"
          isClearable
        />
      </div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Bill To
        </label>
        <Select
          id="bill_to"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          isMulti
          name="bill_to"
          options={basicData?.data?.shops || []}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={basicData?.data?.shops?.filter((m) =>
            formik.values.bill_to?.includes?.(m._id)
          )}
          onChange={(value) =>
            formik.setFieldValue(
              "bill_to",
              value?.map((v) => v._id) || []
            )
          }
          menuPlacement="auto"
          isClearable
        />
      </div>
      <div
        className={`col-12 pro-d-flex pro-justify-end ${"offcanvas-footer-sticky-btn"}`}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleReset}>
          Reset
        </Button>

        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default Filter;
